import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const proofComponentStyles = makeStyles((theme) => ({
    title: {
        fontSize:"0.75rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().bold,
    },
    titleType: {
        fontSize:"0.875rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().bold,
        margin: "8px 0px 2px 0px"
    },
    addtitle: {
        fontSize:"0.875rem",
        color: "#5078E1",
        fontWeight: 500,
        fontFamily: FontFamilySwitch().bold,
        cursor: "pointer",
        backgroundColor: "white",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "white",
            boxShadow: "none",
        },
    },
    menuList: {
        "& .MuiPopover-paper": {
            boxShadow: "0px 0px 6px #0717411F",
            borderRadius: theme.palette.borderRadius,
            backgroundColor: "white",
            padding: "0px"
        }
    },
    menuItem: {
        borderBottom: "1px solid #E4E8EE",
        margin: "0px",
        fontSize:"0.875rem",
        color: "#071741",
        fontFamily: FontFamilySwitch().semiBold,
        '&:last-child': {
            border: 0,
        },
    },
    label: {
        fontFamily: FontFamilySwitch().semiBold,
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        marginBottom: "4px"

    },
    uploadBtn: {
        "&:hover": {
            color: "white",
        },
        marginTop: "16px",
        padding: "10px 18px"
    },
    rootUpload: {
        border: "1px solid #5078E1",
        height: "44px",
        cursor: "pointer",
        borderRadius: "4px",
        position: "relative",
    },

    uploadlabel: {
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().semiBold,
        color: "#5078E1",
        marginInlineStart: "8px",
    },
    uploadIcon: {
        fontSize: "24px",
        color: "#5078E1"

    },
    uploadedimg: {
        width: "100%",
        objectFit: "contain",
        height: "120px",
        borderRadius: "4px",
    },
    previewRoot: {
        backgroundColor: "#F5F7FA",
        borderRadius: "4px",
        padding: "12px 12px 8px 12px",
        marginTop: "16px"
    },
    fileName: {
        fontSize:"0.75rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().bold,
        marginLeft: "8px",
    },
    fileroot: {
        backgroundColor: "#DEEAFC",
        height: "150px",
        fontSize:"0.75rem",
        color: "#5078E1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: theme.palette.borderRadius,
        cursor: "pointer",
        padding: "20px"

    },
    imgContainer: {
        width: "100%",
        borderRadius: theme.palette.borderRadius,
    },
    delete: {
        color: "red",
        position: "absolute",
        top: "12px",
        right: "11px",

        backgroundColor: "white",
        padding: "8px"
    },
    wrapper: {
        width: "100%"
    },
    fileContainer: {
        border: "1px solid #5078E1",
        borderStyle: "dashed",
        borderRadius: "4px",
        padding: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        cursor: "pointer",
        backgroundColor: "#F9FAFB",
        height: "150px",
        width: "100%",
    },
    uploadIcon: {
        fontSize: "36px",
        color: "#5078E1",
        marginBottom: "8px"
    },
    uploadLabel: {
        fontSize: "0.875rem",
        color: "#5078E1",
        fontFamily: FontFamilySwitch().semiBold,
        textAlign: "center"
    },
    helperText: {
        fontSize: "0.75rem",
        color: "#4E5A6B",
        fontFamily: FontFamilySwitch().regular,
        marginTop: "8px",
        textAlign: "center"
    }

}));